import { API_BASE_URL, getAuthHeaderValue } from './api';

export async function transcribeAudio(file: Blob, language?: string, model?: string): Promise<{
  success: boolean;
  text?: string;
  message?: string;
}> {
  try {
    const formData = new FormData();
    formData.append('audio', file, 'speech.webm');
    if (language) formData.append('language', language);
    if (model) formData.append('model', model);

    const authHeader = getAuthHeaderValue();
    const res = await fetch(`${API_BASE_URL}/juben/asr/transcribe`, {
      method: 'POST',
      headers: {
        ...(authHeader ? { Authorization: authHeader } : {}),
      },
      body: formData
    });
    if (!res.ok) {
      return { success: false, message: await res.text() };
    }
    const data = await res.json();
    return {
      success: Boolean(data?.success),
      text: data?.data?.text || '',
      message: data?.message,
    };
  } catch (error) {
    return {
      success: false,
      text: '',
      message: error instanceof Error ? `ASR转写暂不可用：${error.message}` : 'ASR转写暂不可用',
    };
  }
}
